import { render, staticRenderFns } from "./caozuoshouce.vue?vue&type=template&id=56b770f0&scoped=true"
import script from "./caozuoshouce.vue?vue&type=script&lang=js"
export * from "./caozuoshouce.vue?vue&type=script&lang=js"
import style0 from "./caozuoshouce.vue?vue&type=style&index=0&id=56b770f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b770f0",
  null
  
)

export default component.exports